import React from 'react';
import styled, { keyframes } from 'styled-components';

const gradientAnimation = keyframes`
  0% {
    background-position-x: -200%;
  }
  100% {
    background-position-x: 200%;
  }
`;

const SkeletonContainer = styled.div`
  text-align: center;
  background: #f8f9fa;
  padding: 24px;
  border-radius: 12px;
  position: relative;
  height: 180px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 20px rgba(26, 26, 46, 0.1);
  margin-bottom: 20px;
`;

const SkeletonElement = styled.div`
  background: linear-gradient(
    90deg,
    #f0f0f0 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200% 100%;
  background-position-x: -200%;
  animation: 1.5s ${gradientAnimation} ease-in-out infinite;
  border-radius: 4px;
`;

const ProgressSkeleton = styled(SkeletonElement)`
  position: absolute;
  right: 15px;
  top: 15px;
  width: 60px;
  height: 24px;
  border-radius: 15px;
`;


const TitleSkeleton = styled(SkeletonElement)`
  width: 80%;
  height: 24px;
  margin-top: 20px;
  margin-bottom: 5px;
  border-radius: 6px;
`;

const SubtitleSkeleton = styled(SkeletonElement)`
  width: 60%;
  height: 16px;
  margin-bottom: 15px;
  border-radius: 4px;
`;

const ContactContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const ContactSkeleton = styled(SkeletonElement)`
  width: 120px;
  height: 20px;
  border-radius: 4px;
`;

const ContactIconSkeleton = styled(SkeletonElement)`
  width: 16px;
  height: 16px;
  border-radius: 50%;
`;

const UnitSkeleton = ({ id }) => {
  return (
    <SkeletonContainer id={id}>
      <ProgressSkeleton id={`${id}-progress`} />
      <TitleSkeleton id={`${id}-title`} />
      <SubtitleSkeleton id={`${id}-subtitle`} />
      <ContactContainer id={`${id}-contact-container`}>
        <ContactSkeleton id={`${id}-contact`} />
        <ContactIconSkeleton id={`${id}-contact-icon`} />
      </ContactContainer>
    </SkeletonContainer>
  );
};

export default UnitSkeleton;
